import styled from "styled-components"
import { purpleColors, slateColors, Section, Container, TitleHighlight } from '../ContentPages/AppLandingPage/styles';
import API from "./Data";
import PromoCard from "./PromoCard";
import { useTranslation } from 'react-i18next';

const FeaturesSection = styled(Section)`
  background: white;
  padding: 3rem 1.5rem;
  
  @media (min-width: 768px) {
    padding: 4rem 3rem;
  }
`;

const FeaturesContainer = styled(Container)`
  max-width: 80rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  color: ${slateColors[900]};
  margin-bottom: 1rem;
  text-align: center;
  line-height: 1.2;
  
  @media (min-width: 640px) {
    font-size: 2.25rem;
  }
  
  @media (min-width: 768px) {
    font-size: 3rem;
    margin-bottom: 1.5rem;
  }
`;

const SectionDescription = styled.p`
  font-size: 1.125rem;
  color: ${slateColors[600]};
  max-width: 48rem;
  margin: 0 auto 3rem;
  text-align: center;
  line-height: 1.6;
  
  @media (min-width: 768px) {
    font-size: 1.25rem;
    margin-bottom: 4rem;
  }
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  
  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
  
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
`;

const HomeScreenContent = () => {
  const { t } = useTranslation();
  
  const features = [
    {
      imageUrl: "/images/KPIs.png",
      title: t('homeScreen.content.noMoreSurprises.title'),
      body: t('homeScreen.content.noMoreSurprises.body'),
    },
    {
      imageUrl: "/images/Scores.png",
      title: t('homeScreen.content.trainReliability.title'),
      body: t('homeScreen.content.trainReliability.body'),
    },
    {
      imageUrl: "/images/Transfer.png",
      title: t('homeScreen.content.neverMissTrain.title'),
      body: t('homeScreen.content.neverMissTrain.body'),
    },
    {
      imageUrl: "/images/Alternatives.png",
      title: t('homeScreen.content.buildIdealJourney.title'),
      body: t('homeScreen.content.buildIdealJourney.body'),
    },
    {
      imageUrl: "/images/Chart.png",
      title: t('homeScreen.content.diveDeep.title'),
      body: t('homeScreen.content.diveDeep.body'),
    },
  ];

    return (
    <>
      <FeaturesSection>
        <FeaturesContainer>
          <SectionTitle>{t('homeScreen.content.sectionTitle')} <TitleHighlight>{t('homeScreen.content.sectionTitleHighlight')}</TitleHighlight>?</SectionTitle>
          <SectionDescription>
            {t('homeScreen.content.sectionDescription')}
          </SectionDescription>
          <FeaturesGrid>
            {features.map((feature, index) => (
              <PromoCard
                key={index}
                imageUrl={feature.imageUrl}
                title={feature.title}
                body={feature.body}
              />
            ))}
          </FeaturesGrid>
        </FeaturesContainer>
      </FeaturesSection>
      <API />
    </>
    );
  };
  
  export default HomeScreenContent;
